import { ICellRendererParams } from 'ag-grid-community';
import { connect } from 'react-redux';
import { setViewAllNetworksModal } from '../../../../../../../../../../redux/configuration/virtual-machine-entities/slice';
import { RootState } from '../../../../../../../../../../redux/store';
import { NetworkOrVlansCellRenderer } from '.';

type NetworkOrVlansCellRendererOwnProps = Pick<ICellRendererParams, 'data'> & {
  networks?: Network[];
};

const mapDispatchToProps = {
  setViewAllNetworksModal,
};

const mapStateToProps = (
  _: RootState,
  ownProps: NetworkOrVlansCellRendererOwnProps,
) => ({
  networks: ownProps.networks,
  nic: ownProps.data as VmNetworkInterfaceToEdit | HardwareNetworkInterface,
});

export type NetworkOrVlansCellRendererProps = ReturnType<
  typeof mapStateToProps
> &
  typeof mapDispatchToProps;

export const NetworkOrVlansCellRendererContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NetworkOrVlansCellRenderer);
